// extracted by mini-css-extract-plugin
export default {"root":"ClearInputBoxButton_root__HK1KE"};